
const sidebar_user_profile_icon_url = "https://azolla-asset.s3.ap-south-1.amazonaws.com/img-assets/sidebar_user_profile_icon.jpg"
const login_background_img_url = "https://azolla-asset.s3.ap-south-1.amazonaws.com/img-assets/login_background_img.png"
const signup_background_img_url = "https://azolla-asset.s3.ap-south-1.amazonaws.com/img-assets/signup_background_img.png"
// const hostname="http://azolla-env.eba-zifmyrzb.ap-south-1.elasticbeanstalk.com/"
// const hostname = "http://azolla-env-uat.ap-south-1.elasticbeanstalk.com/"
const hostname = "https://be.azolla.sg/"
// const hostname = "http://127.0.0.1:8000/"

export { sidebar_user_profile_icon_url, login_background_img_url, hostname, signup_background_img_url }